import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class DialogAdapter {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Remove this comment and fix warnings!
	close!: (result: any) => void;
	result: unknown;
}
